module.exports = __webpack_public_path__ + "static/media/logofinal.6cced3ea.png";